import { useFormContext } from 'react-hook-form';

export interface FormCustomContext {
    readOnly: boolean;
}

/**
 * To consume the context, you need to provide it to `useForm` when using `FormProvider`.
 * It uses internal react-hook-form API, because there's no better way to get the context on the field level.
 */
export const useCustomContext = () => {
    const {
        control: {
            _options: { context },
        },
    } = useFormContext<object, FormCustomContext>();
    return context;
};
